<nav class="bg-white border-gray-200 w-full xl:text-sm">
  <cdk-accordion
    class="grid grid-cols-2 xl:flex gap-4 items-stretch justify-between p-4 xl:px-10 mx-auto"
  >
    <div class="xl:w-96 flex items-center gap-4">
      <a
        class="text-5xl leading-none font-peinture text-primary hover:text-primary-600"
        routerLink="/"
      >
        Skillz
      </a>
      <app-ghosting class="justify-center"></app-ghosting>
    </div>
    <button
      type="button"
      class="justify-self-end inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-md xl:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
      aria-controls="navbar-cta"
      aria-expanded="false"
      data-testid="menu-button"
      (click)="toggleMobileNav()"
    >
      <span class="sr-only" i18n>Open main menu</span>
      <svg
        class="w-5 h-5"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 17 14"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M1 1h15M1 7h15M1 13h15"
        />
      </svg>
    </button>
    <div
      class="flex-wrap gap-4 justify-end w-full col-span-2 xl:flex xl:w-96 order-2 space-x-3 xl:space-x-0 rtl:space-x-reverse"
      [ngClass]="{ hidden: !opened }"
    >
      <div class="flex gap-4 items-center">
        <app-shopping-cart-icon></app-shopping-cart-icon>
        @if (user(); as user) {
          <ul
            class="font-medium pl-2 rounded-md xl:flex xl:p-0 xl:space-x-8 xl:items-center xl:flex-row rtl:space-x-reverse"
          >
            <li>
              <nav-menu
                [text]="user.firstName || profileText"
                class="hover:text-primary hidden xl:inline-block"
                data-testid="profile-nav"
              >
                <nav-menu-link
                  i18n-text
                  text="Customer Profile"
                  link="/profile"
                />
                @if (user | isMonitor) {
                  <nav-menu-link
                    i18n-text
                    text="Monitor Dashboard"
                    link="/portal/monitor"
                  />
                }
                @if (user | isExternal) {
                  <nav-menu-link
                    i18n-text
                    text="Organization Dashboard"
                    link="/portal/external/dashboard"
                  />
                }
                @if (user | isAdmin) {
                  <nav-menu-link
                    i18n-text
                    text="Admin Dashboard"
                    link="/portal/admin/dashboard"
                  />
                }
                <nav-menu-link
                  role="button"
                  i18n-text
                  text="Log out"
                  link="#"
                  (click)="auth.logout()"
                />
              </nav-menu>
              <!-- Only visible during mobile nav -->
              <nav-menu-accordion
                [text]="user.firstName || profileText"
                class="hover:text-primary xl:hidden"
                data-testid="profile-nav"
              >
                <nav-menu-link
                  i18n-text
                  text="Customer Profile"
                  link="/profile"
                  (click)="toggleMobileNav()"
                />
                @if (user | isMonitor) {
                  <nav-menu-link
                    i18n-text
                    text="Monitor Dashboard"
                    link="/portal/monitor"
                    (click)="toggleMobileNav()"
                  />
                }
                @if (user | isExternal) {
                  <nav-menu-link
                    i18n-text
                    text="Organization Dashboard"
                    link="/portal/external/dashboard"
                    (click)="toggleMobileNav()"
                  />
                }
                @if (user | isAdmin) {
                  <nav-menu-link
                    i18n-text
                    text="Admin Dashboard"
                    link="/portal/admin/dashboard"
                    (click)="toggleMobileNav()"
                  />
                }
                <nav-menu-link
                  role="button"
                  i18n-text
                  text="Log out"
                  link="#"
                  (click)="auth.logout()"
                />
              </nav-menu-accordion>
            </li>
          </ul>
        } @else if (user() === undefined) {
          <!-- Still loading -->
          <div class="animate-pulse w-20 h-[1rem] bg-gray-300"></div>
        } @else {
          <a
            class="button-outline button-outline-secondary text-sm"
            i18n-routerLink="@@//become-monitor"
            routerLink="/become-monitor"
            i18n
          >
            Apply for Monitor
          </a>
          <button
            class="button text-sm"
            data-testid="login-button"
            (click)="auth.loginWithRedirect()"
            i18n
          >
            Log In
          </button>
        }
      </div>
    </div>
    <div
      class="items-center justify-between w-full col-span-2 xl:flex xl:w-auto order-1"
      [ngClass]="{ hidden: !opened }"
    >
      <ul
        class="w-full flex flex-col justify-center font-medium pl-2 xl:p-0 rounded-md xl:space-x-8 rtl:space-x-reverse xl:flex-row"
      >
        <li class="pb-2 xl:p-0">
          <a
            class="hover:text-primary"
            routerLink="/"
            i18n
            (click)="toggleMobileNav()"
          >
            Home
          </a>
        </li>
        <li class="pb-2 xl:p-0">
          <a i18n class="hover:text-primary" i18nRouterLink="/courses">Camps</a>
        </li>
        <li class="pb-2 xl:p-0">
          <nav-menu
            i18n-text
            text="Schools & organizations"
            class="hover:text-primary hidden xl:inline-block"
          >
            <nav-menu-link i18n-text text="Workshops" link="/workshops" />
            <nav-menu-link
              i18n-text
              text="After school lessons"
              link="/after-school"
            />
            <nav-menu-link i18n-text text="Custom camps" link="/custom-camps" />
          </nav-menu>

          <!-- Only visible during mobile nav -->
          <nav-menu-accordion
            i18n-text
            text="Schools & organizations"
            class="hover:text-primary xl:hidden"
          >
            <nav-menu-link
              i18n-text
              text="Workshops"
              link="/workshops"
              (click)="toggleMobileNav()"
            />
            <nav-menu-link
              i18n-text
              text="After school lessons"
              link="/after-school"
              (click)="toggleMobileNav()"
            />
            <nav-menu-link
              i18n-text
              text="Custom camps"
              link="/custom-camps"
              (click)="toggleMobileNav()"
            />
          </nav-menu-accordion>
        </li>

        <li class="pb-2 xl:p-0">
          <nav-menu
            i18n-text
            text="Contact"
            class="hover:text-primary hidden xl:inline-block"
          >
            <nav-menu-link
              i18n-text
              text="The Skillz team"
              link="/skillz-team"
            />
            <nav-menu-link i18n-text text="FAQ" link="/faq" />
            <nav-menu-link i18n-text text="Contact us" link="/contact-us" />
          </nav-menu>

          <!-- Only visible during mobile nav -->
          <nav-menu-accordion
            i18n-text
            text="Contact"
            class="hover:text-primary xl:hidden"
          >
            <nav-menu-link
              i18n-text
              text="The Skillz team"
              link="/skillz-team"
              (click)="toggleMobileNav()"
            />
            <nav-menu-link
              i18n-text
              text="FAQ"
              i18n-link="@@//faq"
              link="/faq"
              (click)="toggleMobileNav()"
            />
            <nav-menu-link
              i18n-text
              text="Contact us"
              link="/contact-us"
              (click)="toggleMobileNav()"
            />
          </nav-menu-accordion>
        </li>
      </ul>
    </div>
  </cdk-accordion>
</nav>
